import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsGuest } from 'redux/db/reducers';
import { layout } from 'tokens';
import * as S from './styles';

interface NavbarLeftProps {
	children: React.ReactNode;
	width?: number;
}

const NavbarLeft = ({ children, width }: NavbarLeftProps) => {
	const { sidebarDocked, isGuest } = useSelector((r: RootReducer) => {
		return {
			sidebarDocked: r.mode.sidebarDocked,
			isGuest: selectIsGuest(r.db),
		};
	}, shallowEqual);

	const makeSpaceForSidebar = !isGuest && !sidebarDocked;
	const navbarPadding = makeSpaceForSidebar ? layout.sidebarToggleWidth : 6;
	const adjustedWidth = width ? width - navbarPadding : undefined;

	return <S.Base $width={adjustedWidth}>{children}</S.Base>;
};

export default NavbarLeft;
